// extracted by mini-css-extract-plugin
module.exports = {"dot-shape":"styles_dot-shape__vTIBr"};